/* Raw Water Co. v2 — contact topic chips (single-select radio styling). */
(function () {
  function init(group) {
    if (group.dataset.v2Init) return;
    group.dataset.v2Init = "1";
    var chips = group.querySelectorAll(".v2-contact__chip");
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        chips.forEach(function (c) { c.classList.remove("v2-contact__chip--active"); });
        chip.classList.add("v2-contact__chip--active");
      });
    });
  }
  function initAll() { document.querySelectorAll("[data-v2-chips]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", initAll);
})();
